import React, { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NoInternet from "@src/components/NoInternet/NoInternet";
import Cookies from "js-cookie";
import HeaderSkeleton from "@src/components/Skeleton/Header/HeaderSkeleton";
import FooterSkeleton from "@src/components/Skeleton/Footer/FooterSkeleton";

const Header = React.lazy(() => import("@components/Header/Header"));
const Footer = React.lazy(() => import("@components/Footer/Footer"));

const CommonLayout: React.FC = React.memo(() => {
  const { pathname } = useLocation();

  return (
    <main>
      <Suspense fallback={<HeaderSkeleton />}>
        <Header />
      </Suspense>
      {!navigator.onLine &&
      Cookies.get("aT") &&
      !pathname.includes("downloads") &&
      !pathname.includes("/episode/") ? (
        <NoInternet />
      ) : (
        <div className="min-h-[calc(100dvh-260px)] max-xl:min-h-[calc(100dvh-248px)] max-lg:min-h-[calc(100dvh-240px)] max-md:min-h-[calc(100dvh-206px)]">
          <div id="outlettop"></div>
          <Outlet />
        </div>
      )}
      <Suspense fallback={<FooterSkeleton />}>
        <Footer />
      </Suspense>
    </main>
  );
});

export default CommonLayout;
